<template>
  <div class="view moment" data-name="moment">
    <RailsContent :data="medium" :is-medium="true" />
    <PageHero :title="'What\'s New.'" />
  </div>
</template>

<script>
import PageHero from '@/components/heros/PageHero.vue';
import RailsContent from '@/components/contents/RailsContent.vue';
import cursor from '@/scripts/cursor';

export default {
  name: 'moment',

  components: {
    PageHero,
    RailsContent,
  },

  data() {
    return {
      medium: [],
    };
  },

  mounted() {
    // fetch('https://us-central1-zonin-prosecco.cloudfunctions.net/mediumFeed')
    //   .then(response => response.json())
    //   .then((medium) => {
    //     this.medium = medium.rss.channel[0].item;
    //     this.$nextTick(() => {
    //       cursor.readd('apollo-medium', this.$el);
    //     });
    //   });
    Object.keys(this.$store.state.posts).forEach((key) => {
      this.medium.push({ ...this.$store.state.posts[key], key });
    });
    this.$nextTick(() => {
      cursor.readd('apollo-medium', this.$el);
    });
  },

  beforeDestroy() {
    cursor.remove('apollo-medium');
  },
};
</script>
